/* tslint:disable */

/**
 */
export class layoutResults {
    LOADING_RATE?: number;
    ID_LAYOUT_RESULTS?: number;
    NUMBER_PER_M?: number;
    NUMBER_IN_WIDTH?: number;
    LEFT_RIGHT_INTERVAL?: number;
    ID_STUDY_EQUIPMENTS?: number;
    QUANTITY_PER_BATCH?: number;
    LOADING_RATE_MAX?: number;
    QUANTITY_PER_BATCH_MAX?: number;
    NB_SHELVES?: number;
    NB_SHELVES_MAX?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/layout-results.ts